import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [NgClass],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() class: string;
  @Input() iconClass: string | null;
  @Input() id: string;
  @Input() label: string;
  @Input() type: string = 'submit';
  @Input() spinner: boolean = true;
  @Input() disabled: boolean = false;
  @Input() data: any;

  public buttonId: string | null;

  public onClick(id: string) {
    this.buttonId = id;
  }
}
